var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"order-status-container"},[_c('figure',{class:_vm.getClass},[_c('i',{class:_vm.getIcon})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.getLabel))])]),_vm._v(" "),_c('div',{staticClass:"modal"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e32be1c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderStatus.vue
// module id = 845
// module chunks = 0